module.exports = __webpack_public_path__ + "static/media/Instant_Motor_Function_Control_Reinforcement.7efc24dd.mp3";